import React, { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { ListItemAvatar } from './ListItemAvatar.js';
import {
  ListItemContainer,
  ListItemContainerElement,
  ListItemContainerProps,
} from './ListItemContainer.js';
import { ListItemText } from './ListItemText.js';

export type ListItemElement = ListItemContainerElement;
export interface ListItemProps extends ListItemContainerProps {
  avatar?: React.ReactNode | React.ReactNode[];
  title: string;
  subtitle?: string;
  secondaryAction?: React.ReactNode | React.ReactNode[];
}

export const ListItem = styled(
  forwardRef<ListItemElement, ListItemProps>(
    ({ avatar, secondaryAction, title, subtitle, ...restProps }, ref) => {
      return (
        <ListItemContainer ref={ref} {...restProps}>
          <ListItemAvatar avatar={avatar} />
          <ListItemText subtitle={subtitle} title={title} />
          {secondaryAction}
        </ListItemContainer>
      );
    }
  )
).withConfig({
  displayName: 'ListItem',
})``;
